// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3pfhU","footer":"ModalError_footer__1gHEE"};